import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import store from "./store/index";
import { Provider } from "react-redux";
import { setResolution } from "./actions/index";


ReactDOM.render(
    <Provider store={store}>
      <App store={store}/>
    </Provider>
        , document.getElementById('root'));
registerServiceWorker();
